module.exports = __webpack_public_path__ + "static/driver0-65d19529757519b85637b5643271effa.jpg";